import React, { useEffect, useRef } from 'react'
import { fetchRazorPayStatus } from '../../redux/personaliseLessons/razorPaySlice'
import { useDispatch } from 'react-redux'
import { RAZORPAY_KEY } from '../../config/api_config'
import useRazorpay from 'react-razorpay'
import { useState } from 'react'
import { ClipLoader } from 'react-spinners'
import { Dialog } from '@headlessui/react'
import { setTrialPeriod } from '../../redux/personaliseLessons/nameSlice'
import CourseDropDown from './CourseDropDown'
import { toast } from 'react-toastify'
import { axiosNoAuth } from '../../redux/personaliseLessons/axiosInstance'


const SubscriptionStatusModal = ({ authentication, isOpen, courseList, courseName, setCourseName }) => {

    const { uid, email, userName, userPhone } = authentication

    const [ loader, setLoader ] = useState(false)
    const [ showDropDown, setShowDropDown ] = useState(false)

    const dropDownRef = useRef(null)

    const dispatch = useDispatch()
    const Razorpay = useRazorpay()

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
                setShowDropDown(false)
            }
        }

        document.addEventListener('click', handleClickOutside)

        return () => {
            document.removeEventListener('click', handleClickOutside)
        }   
    }, [])

    const razorpayHandler = async (callback) => {
        try {
            const response = await axiosNoAuth.post(
                "https://xgfy-czuw-092q.m2.xano.io/api:IfQi_Nyx/razorpay_ninjacurate_payment/create_subscription_test",
                {
                    uid: uid,
                    plan_name: "Personalise Subscription",
                    product_name: "Personalise Subscription"
                }
            )
            const options = {
                key: RAZORPAY_KEY,
                currency: "INR",
                name: userName,
                description: "Personalise Subscription",
                image: "",
                subscription_id: response.data?.subscription_id,
                modal: {
                    "ondismiss": function () {
                    callback()
                    }
                },
                handler: (res) => {
                    getOrderStatusSuccess(res)
                    callback();
                },
                prefill: {
                    name: userName,
                    email: email,
                    contact: userPhone,
                },
                notes: {
                    address: "Razorpay Corporate Office"
                },
                theme: {
                    color: "#26CBA1"
                }
            };
            const rzp1 = new Razorpay(options)
            rzp1.on("payment.failed", function (response) {
                getOrderStatusFailed(response)
                callback()
            })
            rzp1.open()
        } catch (error) {
            toast.error('Something Went Wrong! Try Again')   
        }finally{
            callback()
        }
    }

    const getOrderStatusSuccess = async (response) => {
        await dispatch(fetchRazorPayStatus({
            uuid: uid,
            payment_id: response?.razorpay_payment_id,
            order_id: response?.razorpay_subscription_id,
            isError: false,
            razorpay_signature: response?.razorpay_signature,
            errorObj: {}
        }))
        dispatch(setTrialPeriod(false))
    }

    const getOrderStatusFailed = async (response) => {
        dispatch(fetchRazorPayStatus({
            uuid: uid,
            payment_id: response?.error?.metadata?.payment_id,
            order_id: response?.error?.metadata?.order_id,
            isError: true,
            razorpay_signature: "",
            errorObj: { ...response?.error }
        }))
    }

    return (
        <Dialog
            open={isOpen}
            onClose={() => {}}
            as='div'
            className="absolute inset-0 flex flex-col mx-auto text-white"
        >
            <div ref={dropDownRef} className='z-[80] bg-secondary_background w-[90%] mx-auto overflow-y-scroll my-4'>
                <CourseDropDown
                    courseList={courseList}
                    courseName={courseName}
                    setCourseName={setCourseName}
                    email={email}
                    showDropDown={showDropDown}
                    setShowDropDown={setShowDropDown}
                />
            </div>
            <div className='absolute z-50 inset-0 flex items-center justify-center bg-subscription'>
                <div className=''>
                    <div className='w-1/2 h-full mx-auto'>
                        <img src="https://assets.learntube.ai/files/Onboarding_Revamp/error-404%201.png?updatedAt=1696314942503" width={185} height={185} className='w-full h-auto' alt="" />
                    </div>
                    <h2 className='text-xl w-2/3 mx-auto text-center font-semibold -mt-4 leading-6'>Uh-oh! Your Subscription Has Ended</h2>
                    <p className='text-sm w-4/5 mx-auto font-medium text-center opacity-80 mt-1.5'>Resume subscription to access your existing personalised courses & create unlimited more.</p>
                    <div className='bg-[#7FC241] font-semibold w-2/3 mx-auto flex justify-center items-center text-black py-2 rounded-lg cursor-pointer mt-5' onClick={() => {
                        setLoader(true)
                        razorpayHandler(()=>setLoader(false))
                    }}>
                        {loader ?<ClipLoader color='black' size={20} /> : 'Unlock Unlimited Access'}
                    </div>
                    <p className='text-center mt-1.5 text-sm font-medium'>Only ₹299 <span className='text-[#E06064]'>₹<span className='line-through'>999</span></span> per month</p>
                </div>
            </div>
        </Dialog>
    )
}

export default SubscriptionStatusModal
